import { reactive } from "vue";

export const store = reactive({
  content: [],
});
